import Icon from './Icon.js';
export { default as Icon } from './Icon.js';
export { default as HeaderBar } from './HeaderBar.js';
export { default as IconSymbol } from './IconSymbol.js';
export { default as useDropdownState } from './useDropdownState.js';
export { default as useModalState } from './useModalState.js';
export { default as useAnimatedModalState } from './useAnimatedModalState.js';
export { default as useCopyToClipboard } from './useCopyToClipboard.js';
export { default as useModalPortal } from './useModalPortal.js';
export { default as useMode } from './useMode.js';
export { default as useSidebarState } from './useSidebarState.js';
export { default as IconActivity } from './IconActivity.js';
export { default as IconAd } from './IconAd.js';
export { default as IconAlignBleed } from './IconAlignBleed.js';
export { default as IconAlignEdge } from './IconAlignEdge.js';
export { default as IconAlignHeader } from './IconAlignHeader.js';
export { default as IconAlignInline } from './IconAlignInline.js';
export { default as IconAlignOffset } from './IconAlignOffset.js';
export { default as IconAlignWrap } from './IconAlignWrap.js';
export { default as IconArticle } from './IconArticle.js';
export { default as IconArchive } from './IconArchive.js';
export { default as IconAreaChart } from './IconAreaChart.js';
export { default as IconArrowDown } from './IconArrowDown.js';
export { default as IconArrowLeft } from './IconArrowLeft.js';
export { default as IconArrowRight } from './IconArrowRight.js';
export { default as IconArrowUp } from './IconArrowUp.js';
export { default as IconAward } from './IconAward.js';
export { default as IconAxes } from './IconAxes.js';
export { default as IconBarChartHor } from './IconBarChartHor.js';
export { default as IconBarChartVer } from './IconBarChartVer.js';
export { default as IconBell } from './IconBell.js';
export { default as IconBellOff } from './IconBellOff.js';
export { default as IconBlockquote } from './IconBlockquote.js';
export { default as IconBlocks } from './IconBlocks.js';
export { default as IconBold } from './IconBold.js';
export { default as IconBook } from './IconBook.js';
export { default as IconBookOpen } from './IconBookOpen.js';
export { default as IconBriefcase } from './IconBriefcase.js';
export { default as IconBug } from './IconBug.js';
export { default as IconCalendar } from './IconCalendar.js';
export { default as IconCamera } from './IconCamera.js';
export { default as IconCameraOff } from './IconCameraOff.js';
export { default as IconCaretDown } from './IconCaretDown.js';
export { default as IconCaretLeft } from './IconCaretLeft.js';
export { default as IconCaretRight } from './IconCaretRight.js';
export { default as IconCaretUp } from './IconCaretUp.js';
export { default as IconCheck } from './IconCheck.js';
export { default as IconCheckCircle } from './IconCheckCircle.js';
export { default as IconCheckSquare } from './IconCheckSquare.js';
export { default as IconChevronsDown } from './IconChevronsDown.js';
export { default as IconChevronsLeft } from './IconChevronsLeft.js';
export { default as IconChevronsRight } from './IconChevronsRight.js';
export { default as IconChevronsUp } from './IconChevronsUp.js';
export { default as IconCircle } from './IconCircle.js';
export { default as IconCircleFilled } from './IconCircleFilled.js';
export { default as IconClipboard } from './IconClipboard.js';
export { default as IconClock } from './IconClock.js';
export { default as IconCloud } from './IconCloud.js';
export { default as IconCloudDownload } from './IconCloudDownload.js';
export { default as IconCloudDrizzle } from './IconCloudDrizzle.js';
export { default as IconCloudLightning } from './IconCloudLightning.js';
export { default as IconCloudOff } from './IconCloudOff.js';
export { default as IconCloudRain } from './IconCloudRain.js';
export { default as IconCloudSnow } from './IconCloudSnow.js';
export { default as IconCloudUpload } from './IconCloudUpload.js';
export { default as IconCode } from './IconCode.js';
export { default as IconCode2 } from './IconCode2.js';
export { default as IconCoffee } from './IconCoffee.js';
export { default as IconColor } from './IconColor.js';
export { default as IconColumns } from './IconColumns.js';
export { default as IconCommand } from './IconCommand.js';
export { default as IconCopy } from './IconCopy.js';
export { default as IconCornerDownLeft } from './IconCornerDownLeft.js';
export { default as IconCornerDownRight } from './IconCornerDownRight.js';
export { default as IconCornerLeftDown } from './IconCornerLeftDown.js';
export { default as IconCornerLeftUp } from './IconCornerLeftUp.js';
export { default as IconCornerRightDown } from './IconCornerRightDown.js';
export { default as IconCornerRightUp } from './IconCornerRightUp.js';
export { default as IconCornerUpLeft } from './IconCornerUpLeft.js';
export { default as IconCornerUpRight } from './IconCornerUpRight.js';
export { default as IconCr } from './IconCr.js';
export { default as IconCrop } from './IconCrop.js';
import IconCross from './IconCross.js';
export { default as IconCross } from './IconCross.js';
export { default as IconCrossCircle } from './IconCrossCircle.js';
export { default as IconCrossSquare } from './IconCrossSquare.js';
export { default as IconDuplicate } from './IconDuplicate.js';
export { default as IconDatabase } from './IconDatabase.js';
export { default as IconDeck } from './IconDeck.js';
export { default as IconDiamond } from './IconDiamond.js';
export { default as IconDiamondFilled } from './IconDiamondFilled.js';
export { default as IconDisabled } from './IconDisabled.js';
export { default as IconDivider } from './IconDivider.js';
export { default as IconDjRiskJournal } from './IconDjRiskJournal.js';
export { default as IconDocumentReview } from './IconDocumentReview.js';
export { default as IconDollar } from './IconDollar.js';
export { default as IconDownload } from './IconDownload.js';
export { default as IconEdit } from './IconEdit.js';
export { default as IconEdit2 } from './IconEdit2.js';
export { default as IconError } from './IconError.js';
export { default as IconEvergreen } from './IconEvergreen.js';
export { default as IconExternalLink } from './IconExternalLink.js';
export { default as IconEye } from './IconEye.js';
export { default as IconEyeOff } from './IconEyeOff.js';
export { default as IconFaceHappy } from './IconFaceHappy.js';
export { default as IconFaceNeutral } from './IconFaceNeutral.js';
export { default as IconFaceSad } from './IconFaceSad.js';
export { default as IconFacebook } from './IconFacebook.js';
export { default as IconFastForward } from './IconFastForward.js';
export { default as IconFile } from './IconFile.js';
export { default as IconFileMinus } from './IconFileMinus.js';
export { default as IconFilePlus } from './IconFilePlus.js';
export { default as IconFilePoll } from './IconFilePoll.js';
export { default as IconFileText } from './IconFileText.js';
export { default as IconFilter } from './IconFilter.js';
export { default as IconFlag } from './IconFlag.js';
export { default as IconFolder } from './IconFolder.js';
export { default as IconFormFeedback } from './IconFormFeedback.js';
export { default as IconFormPoll } from './IconFormPoll.js';
export { default as IconFormQuiz } from './IconFormQuiz.js';
export { default as IconGavel } from './IconGavel.js';
export { default as IconGear } from './IconGear.js';
export { default as IconGift } from './IconGift.js';
export { default as IconGithub } from './IconGithub.js';
export { default as IconGrid } from './IconGrid.js';
export { default as IconHandle } from './IconHandle.js';
export { default as IconHash } from './IconHash.js';
export { default as IconHeader } from './IconHeader.js';
export { default as IconHeadline } from './IconHeadline.js';
export { default as IconHeart } from './IconHeart.js';
export { default as IconHeartFilled } from './IconHeartFilled.js';
export { default as IconHelp } from './IconHelp.js';
export { default as IconHistory } from './IconHistory.js';
export { default as IconHome } from './IconHome.js';
export { default as IconIbd } from './IconIbd.js';
export { default as IconImage } from './IconImage.js';
export { default as IconImageGallery } from './IconImageGallery.js';
export { default as IconInbox } from './IconInbox.js';
export { default as IconInfinity } from './IconInfinity.js';
export { default as IconInfo } from './IconInfo.js';
export { default as IconInstagram } from './IconInstagram.js';
export { default as IconItalics } from './IconItalics.js';
export { default as IconKey } from './IconKey.js';
export { default as IconLayoutLeft } from './IconLayoutLeft.js';
export { default as IconLayoutRight } from './IconLayoutRight.js';
export { default as IconLifeBuoy } from './IconLifeBuoy.js';
export { default as IconLightbox } from './IconLightbox.js';
export { default as IconLineChart } from './IconLineChart.js';
export { default as IconLink } from './IconLink.js';
export { default as IconLinkedin } from './IconLinkedin.js';
export { default as IconList } from './IconList.js';
export { default as IconLoader } from './IconLoader.js';
export { default as IconLock } from './IconLock.js';
export { default as IconLogIn } from './IconLogIn.js';
export { default as IconLogOut } from './IconLogOut.js';
export { default as IconMail } from './IconMail.js';
export { default as IconMap } from './IconMap.js';
export { default as IconMapMarker } from './IconMapMarker.js';
export { default as IconMaximize } from './IconMaximize.js';
export { default as IconMenu } from './IconMenu.js';
export { default as IconMessageCircle } from './IconMessageCircle.js';
export { default as IconMessageDots } from './IconMessageDots.js';
export { default as IconMessageSquare } from './IconMessageSquare.js';
export { default as IconMic } from './IconMic.js';
export { default as IconMinimize } from './IconMinimize.js';
export { default as IconMinus } from './IconMinus.js';
export { default as IconMinusCircle } from './IconMinusCircle.js';
export { default as IconMonitor } from './IconMonitor.js';
export { default as IconMoon } from './IconMoon.js';
export { default as IconMusic } from './IconMusic.js';
export { default as IconNewspaper } from './IconNewspaper.js';
export { default as IconNumber } from './IconNumber.js';
export { default as IconPackage } from './IconPackage.js';
export { default as IconPaperclip } from './IconPaperclip.js';
export { default as IconParagraph } from './IconParagraph.js';
export { default as IconPause } from './IconPause.js';
export { default as IconPauseCircle } from './IconPauseCircle.js';
export { default as IconPencil } from './IconPencil.js';
export { default as IconPercent } from './IconPercent.js';
export { default as IconPhone } from './IconPhone.js';
export { default as IconPieChart } from './IconPieChart.js';
export { default as IconPin } from './IconPin.js';
export { default as IconPlay } from './IconPlay.js';
export { default as IconPlayCircle } from './IconPlayCircle.js';
export { default as IconPlus } from './IconPlus.js';
export { default as IconPlusCircle } from './IconPlusCircle.js';
export { default as IconPrinter } from './IconPrinter.js';
export { default as IconProgress } from './IconProgress.js';
export { default as IconPullQuote } from './IconPullQuote.js';
export { default as IconPylon } from './IconPylon.js';
export { default as IconRefresh } from './IconRefresh.js';
export { default as IconRepeat } from './IconRepeat.js';
export { default as IconRewind } from './IconRewind.js';
export { default as IconRss } from './IconRss.js';
export { default as IconSave } from './IconSave.js';
export { default as IconScatterChart } from './IconScatterChart.js';
export { default as IconScissors } from './IconScissors.js';
export { default as IconSearch } from './IconSearch.js';
export { default as IconSend } from './IconSend.js';
export { default as IconShare } from './IconShare.js';
export { default as IconShare2 } from './IconShare2.js';
export { default as IconShuffle } from './IconShuffle.js';
export { default as IconSidebar } from './IconSidebar.js';
export { default as IconSkipBack } from './IconSkipBack.js';
export { default as IconSkipForward } from './IconSkipForward.js';
export { default as IconSlack } from './IconSlack.js';
export { default as IconSliders } from './IconSliders.js';
export { default as IconSmartphone } from './IconSmartphone.js';
export { default as IconSort } from './IconSort.js';
export { default as IconSortReverse } from './IconSortReverse.js';
export { default as IconSquare } from './IconSquare.js';
export { default as IconSquareFilled } from './IconSquareFilled.js';
export { default as IconStar } from './IconStar.js';
export { default as IconStarFilled } from './IconStarFilled.js';
export { default as IconStepChart } from './IconStepChart.js';
export { default as IconSun } from './IconSun.js';
export { default as IconTablet } from './IconTablet.js';
export { default as IconTag } from './IconTag.js';
export { default as IconTextAlignCenter } from './IconTextAlignCenter.js';
export { default as IconTextAlignJustified } from './IconTextAlignJustified.js';
export { default as IconTextAlignLeft } from './IconTextAlignLeft.js';
export { default as IconTextAlignRight } from './IconTextAlignRight.js';
export { default as IconThreeDotsHor } from './IconThreeDotsHor.js';
export { default as IconThreeDotsVer } from './IconThreeDotsVer.js';
export { default as IconThumbsDown } from './IconThumbsDown.js';
export { default as IconThumbsUp } from './IconThumbsUp.js';
export { default as IconToday } from './IconToday.js';
export { default as IconTrash } from './IconTrash.js';
export { default as IconTrendDown } from './IconTrendDown.js';
export { default as IconTrendUp } from './IconTrendUp.js';
export { default as IconTv } from './IconTv.js';
export { default as IconTwitter } from './IconTwitter.js';
export { default as IconTwoColumn } from './IconTwoColumn.js';
export { default as IconType } from './IconType.js';
export { default as IconUmbrella } from './IconUmbrella.js';
export { default as IconUnderline } from './IconUnderline.js';
export { default as IconUndo } from './IconUndo.js';
export { default as IconUnlink } from './IconUnlink.js';
export { default as IconUnlock } from './IconUnlock.js';
export { default as IconUpload } from './IconUpload.js';
export { default as IconUser } from './IconUser.js';
export { default as IconUserCheck } from './IconUserCheck.js';
export { default as IconUserCross } from './IconUserCross.js';
export { default as IconUserMinus } from './IconUserMinus.js';
export { default as IconUserPlus } from './IconUserPlus.js';
export { default as IconUsers } from './IconUsers.js';
export { default as IconVideo } from './IconVideo.js';
export { default as IconVideoOff } from './IconVideoOff.js';
export { default as IconVolume } from './IconVolume.js';
export { default as IconVolume1 } from './IconVolume1.js';
export { default as IconVolume2 } from './IconVolume2.js';
export { default as IconVolumeX } from './IconVolumeX.js';
export { default as IconWarning } from './IconWarning.js';
export { default as IconWatch } from './IconWatch.js';
export { default as IconWifi } from './IconWifi.js';
export { default as IconWifiOff } from './IconWifiOff.js';
export { default as IconWind } from './IconWind.js';
export { default as IconYoutube } from './IconYoutube.js';
export { default as IconZap } from './IconZap.js';
export { default as IconZapOff } from './IconZapOff.js';
export { default as IconZoomIn } from './IconZoomIn.js';
export { default as IconZoomOut } from './IconZoomOut.js';
export { default as IconBarrons } from './IconBarrons.js';
export { default as IconDowjones } from './IconDowjones.js';
export { default as IconFnlondon } from './IconFnlondon.js';
export { default as IconListNumbered } from './IconListNumbered.js';
export { default as IconMansionglobal } from './IconMansionglobal.js';
export { default as IconMansionglobalBoutique } from './IconMansionglobalBoutique.js';
export { default as IconMarketwatch } from './IconMarketwatch.js';
export { default as IconMarketwatchWhole } from './IconMarketwatchWhole.js';
export { default as IconPen } from './IconPen.js';
export { default as IconPenta } from './IconPenta.js';
export { default as IconSnapchat } from './IconSnapchat.js';
export { default as IconThetimes } from './IconThetimes.js';
export { default as IconWsj } from './IconWsj.js';
export { default as IconWsjopinion } from './IconWsjopinion.js';
export { default as IconWsjChina } from './IconWsjChina.js';
export { default as IconWsjJapan } from './IconWsjJapan.js';
export { default as IconFeather } from './IconFeather.js';
export { default as IconWsjcommerce } from './IconWsjcommerce.js';
export { default as IconBookmark } from './IconBookmark.js';
export { default as IconShoppingCart } from './IconShoppingCart.js';
export { default as IconDotGrid } from './IconDotGrid.js';
export { default as IconX } from './IconX.js';
export { default as IconAI } from './IconAI.js';
export { default as IconFocalPoint } from './IconFocalPoint.js';
export { default as IconInteractive } from './IconInteractive.js';
export { default as IconThumbCrop } from './IconThumbCrop.js';
export { default as IconYdj } from './IconYdj.js';
export { default as IconFire } from './IconFire.js';
export { default as IconArticle2 } from './IconArticle2.js';
export { default as IconDiamondsFour } from './IconDiamondsFour.js';
export { default as ResponsiveProvider } from './ResponsiveProvider.js';
export { default as utils } from './utils.js';
import _extends from '@babel/runtime/helpers/extends';
import React, { useRef, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { s as setIcon } from './icons-fde0c050.js';
import { a as addClassNames, c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { a as addSpacingClasses, m as marginPropTypes } from './spacing-7e57ffb0.js';
import { p as props, d as defaults } from './componentEl-c8b73b10.js';
import { G as Group } from './Group-ba54dd0f.js';
export { G as Group } from './Group-ba54dd0f.js';
export { A as Avatar } from './Avatar-a7fa1853.js';
export { W as Wrapper } from './Wrapper-8b44541d.js';
import { T as Toggle } from './Toggle-6bfc032b.js';
export { T as Toggle } from './Toggle-6bfc032b.js';
import { T as Typography } from './Typography-a7729cdc.js';
export { T as Typography } from './Typography-a7729cdc.js';
export { A as AvatarGroup } from './AvatarGroup-e717a0cd.js';
export { B as Box } from './Box-17ae6268.js';
export { B as BrandSelect } from './BrandSelect-d26b14ab.js';
export { C as Combobox } from './Combobox-b21f2f1f.js';
export { D as Divider } from './Divider-95161af2.js';
export { N as NumberedBox } from './NumberedBox-99994126.js';
export { A as AutoNumberedBoxes } from './AutoNumberedBoxes-eda011b0.js';
export { B as Breadcrumbs } from './Breadcrumbs-47af801b.js';
export { B as Button } from './Button-7604c54d.js';
export { F as FabButton } from './FabButton-2ee01c20.js';
export { P as Pagination } from './Pagination-efad4e4f.js';
export { P as PageWrapper } from './PageWrapper-6a749c4f.js';
export { G as Grid } from './Grid-405cf53c.js';
export { S as SvgIcon } from './SvgIcon-1308e965.js';
export { T as Token } from './Token-9784342c.js';
export { C as Checkbox } from './Checkbox-543dc8bd.js';
export { F as FormHelperText } from './FormHelperText-fd91e55f.js';
export { F as FormLabel } from './FormLabel-69bdcdb4.js';
export { I as Illustration } from './Illustration-19b58cb7.js';
export { I as Input } from './Input-9832ee7f.js';
export { L as Logs } from './Logs-55877ec9.js';
export { M as Modal } from './Modal-c8026222.js';
export { D as Dialog } from './Dialog-926dfd82.js';
export { O as Overlay } from './Overlay-c16fe126.js';
export { I as InnerBrowserModel } from './InnerBrowserModel-d8f2b82e.js';
export { R as Radio } from './Radio-d9919ff5.js';
export { R as Responsive } from './Responsive-28d2e028.js';
export { S as Sidebar } from './Sidebar-4c1152c2.js';
export { S as Switch } from './Switch-52a9ab49.js';
export { S as Select } from './Select-bfe2dab0.js';
export { S as SideNav } from './SideNav-b81938c0.js';
export { T as Textarea } from './Textarea-9843f755.js';
export { D as Dropdown } from './Dropdown-f3107464.js';
export { N as Notifications } from './Notifications-2714cd24.js';
export { L as List } from './List-494db18b.js';
export { L as Loader } from './Loader-7b33a1cc.js';
export { L as LoaderBar } from './LoaderBar-55833804.js';
export { H as Header, a as HeaderProvider, u as useHeader } from './Header-69440a21.js';
export { S as Steps } from './Steps-580638e8.js';
export { T as Textblock } from './Textblock-32ef3967.js';
export { T as Toast } from './Toast-6df2ce78.js';
export { T as Tooltip } from './Tooltip-75eb30cd.js';
export { T as Tabs } from './Tabs-4c4d8dd7.js';
export { L as Login } from './Login-d4050bdd.js';
export { T as Table } from './Table-970d2f9a.js';
export { a as ThemeContext, T as ThemeProvider } from './ThemeProvider-b9c8dc07.js';
export { S as Subnav } from './Subnav-4a625be1.js';
export { S as SkipToContent } from './SkipToContent-8703b3fd.js';
export { S as Sticky } from './Sticky-dc19dd37.js';
import './IconBuyside-d16c7e03.js';
import './LogoFallback-03bda8ca.js';
import './body-b70a397b.js';
import './breakpoints-84fde671.js';
import './_commonjsHelpers-6baf5229.js';
import './_variables.es6-63d43442.js';
import './border-27b45cc2.js';
import './zIndex-806dd3b8.js';
import 'react-dom';
import 'downshift';
import './ConditionalFocusTrap-43b4310b.js';

function AlertAction({
  children,
  componentEl: Component,
  className,
  ...otherProps
}) {
  let cssClasses = ['st_alert__action'];
  cssClasses = addClassNames(className, cssClasses);
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), children);
}
AlertAction.propTypes = {
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** HTML element or React Component to render as */
  componentEl: props
};
AlertAction.defaultProps = {
  className: null,
  componentEl: 'a'
};
AlertAction.displayName = 'Alert.Action';

function Alert({
  componentEl: Component,
  className,
  icon,
  margin,
  onDismiss,
  type,
  fullWidth,
  inline,
  floating,
  children,
  autoDismiss,
  autoDismissTime,
  inverse,
  pauseDismissOnMouseover,
  ...otherProps
}) {
  let cssClasses = ['st_alert', `st_alert--${type}`];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  if (fullWidth && !inline) cssClasses.push('st_width--full st_alert--fullwidth');
  if (floating && !inline) cssClasses.push('st_alert--floating');
  if (inline) cssClasses.push('st_alert--inline');
  if (inverse) cssClasses.push('st_inverse');
  const dismissTimer = useRef(false);
  const timeExpire = useRef(Date.now() + autoDismissTime * 1000);
  const alertContainer = useRef();
  const alertContentIcon = setIcon(Icon, icon, {
    className: 'st_alert__icon'
  });
  const handleOnMouseEnter = useCallback(() => {
    clearTimeout(dismissTimer.current);
  }, []);
  const handleOnMouseLeave = useCallback(() => {
    const timeleft = timeExpire.current - Date.now();
    if (timeleft > 0) {
      clearTimeout(dismissTimer.current);
      // eslint-disable-next-line no-use-before-define
      dismissTimer.current = setTimeout(clearAlert, timeleft);
      // eslint-disable-next-line no-use-before-define
    } else clearAlert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const clearAlert = useCallback(() => {
    if (alertContainer.current) {
      alertContainer.current.removeEventListener('mouseenter', handleOnMouseEnter);
      alertContainer.current.removeEventListener('mouseleave', handleOnMouseLeave);
    }
    timeExpire.current = 0;
    if (onDismiss) onDismiss();
  }, [onDismiss, handleOnMouseEnter, handleOnMouseLeave]);

  // update timeExpire if autoDismissTime changes
  useEffect(() => {
    if (autoDismissTime) {
      timeExpire.current = Date.now() + autoDismissTime * 1000;
    }
  }, [autoDismissTime]);

  // handle mouseover/mouseout to pause autodismiss
  useEffect(() => {
    const alertContainerRef = alertContainer?.current;
    if (autoDismiss && onDismiss && pauseDismissOnMouseover && !inline && alertContainerRef) {
      alertContainerRef.addEventListener('mouseenter', handleOnMouseEnter);
      alertContainerRef.addEventListener('mouseleave', handleOnMouseLeave);
      return () => {
        if (dismissTimer.current) clearTimeout(dismissTimer.current);
        alertContainerRef.removeEventListener('mouseenter', handleOnMouseEnter);
        alertContainerRef.removeEventListener('mouseleave', handleOnMouseLeave);
      };
    }
    return undefined;
  }, [autoDismiss, onDismiss, pauseDismissOnMouseover, inline, handleOnMouseEnter, handleOnMouseLeave, alertContainer]);

  // set timer for autodismiss
  useEffect(() => {
    if (autoDismiss && !inline) {
      dismissTimer.current = setTimeout(() => {
        clearAlert();
      }, autoDismissTime * 1000);
      return () => dismissTimer.current && clearTimeout(dismissTimer.current);
    }
    return undefined;
  }, [autoDismiss, onDismiss, autoDismissTime, inline, clearAlert]);

  // handle when X is clicked to manually close Alert
  function handleDismissClick() {
    clearAlert();
  }
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' '),
    role: "alert"
  }, otherProps, {
    ref: alertContainer
  }), /*#__PURE__*/React.createElement(Group, {
    align: "space-between",
    gap: "md",
    wrap: false,
    valign: "start"
  }, /*#__PURE__*/React.createElement(Group, {
    wrap: false,
    gap: "sm",
    valign: "start",
    align: "start"
  }, alertContentIcon, children), onDismiss && !inline && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleDismissClick,
    size: "md",
    className: "st_alert__dismiss",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(IconCross, {
    alt: "dismiss"
  }))));
}
Alert.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for avatar, if any */
  margin: marginPropTypes,
  /** type of alert */
  type: PropTypes.oneOf(['primary', 'success', 'warning', 'error', 'gray']),
  /** whether component should go edge to edge. Not compatible with `inline` */
  fullWidth: PropTypes.bool,
  /** whether component should be overlaid in the middle of the viewport.
   * Not available for `inline` */
  floating: PropTypes.bool,
  /** whether component is the inline version. Not compatible with `fullWidth` */
  inline: PropTypes.bool,
  /** optional icon to be displayed to the left. A screentone icon component, e.g. IconStar */
  icon: PropTypes.any,
  /** callback when alert is dismissed, setting this lets X appear. Not available for `inline` */
  onDismiss: PropTypes.func,
  /** whether to fire onDismiss automatically after X seconds. Not available for `inline` */
  autoDismiss: PropTypes.bool,
  /** how many seconds to wait before firing onDismiss automatically. Not available for `inline`. */
  autoDismissTime: PropTypes.number,
  /** whether to use inverse colors. Works with `inverse` only, since the standard `Alert`
   * does not change across dark/light modes */
  inverse: PropTypes.bool,
  /** whether to pause autodismiss if user holds mouse over the Alert */
  pauseDismissOnMouseover: PropTypes.bool
};
Alert.defaultProps = {
  componentEl: defaults,
  type: 'primary',
  fullWidth: false,
  floating: false,
  margin: null,
  className: null,
  icon: null,
  onDismiss: null,
  autoDismiss: false,
  inline: false,
  autoDismissTime: 3,
  inverse: false,
  pauseDismissOnMouseover: false
};
Alert.Action = AlertAction;

function AnnouncementBar({
  children,
  onDismiss,
  margin,
  className,
  ...otherProps
}) {
  let cssClasses = ['st_announcement-bar'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cssClasses.join(' '),
    role: "alert"
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    className: "st_announcement-bar__content"
  }, children), /*#__PURE__*/React.createElement("button", {
    className: "st_announcement-bar__button st_focusable",
    onClick: onDismiss,
    type: "button",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(IconCross, {
    size: "mlg"
  })));
}
AnnouncementBar.propTypes = {
  /** callback when announcement is dismissed */
  onDismiss: PropTypes.func.isRequired,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for component, if any */
  margin: marginPropTypes
};
AnnouncementBar.defaultProps = {
  className: null,
  margin: null
};

function Select({
  children,
  visibleOnFocus,
  componentEl: Component,
  ...otherProps
}) {
  const classNames = ['st_vhidden'];
  if (visibleOnFocus) classNames.push('st_vhidden--focusable');
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: classNames.join(' ')
  }, otherProps), children);
}
Select.propTypes = {
  /** optional html element override */
  componentEl: props,
  /** whether contents should become visible when child element is in focus */
  visibleOnFocus: PropTypes.bool
};
Select.defaultProps = {
  componentEl: 'div',
  visibleOnFocus: false
};

const modes = [{
  value: 'auto',
  label: 'System'
}, {
  value: 'light',
  label: 'Light'
}, {
  value: 'dark',
  label: 'Dark'
}];

/**
Component to render app name and environment
*/
function ThemeToggle({
  mode,
  onUpdate,
  margin,
  className,
  componentEl: Component,
  ...otherProps
}) {
  let cssClasses = [];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
    className: cssClasses.join(' ')
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "label3"
  }, "Theme"), /*#__PURE__*/React.createElement(Toggle, _extends({}, otherProps, {
    onChange: onUpdate,
    value: mode
  }), modes.map(m => /*#__PURE__*/React.createElement(Toggle.Item, {
    value: m.value,
    key: m.value
  }, m.label))));
}
ThemeToggle.propTypes = {
  /**
   * The current mode, based on modes provided by the ThemeProvider
   */
  mode: PropTypes.oneOf(['light', 'dark', 'auto']),
  /**
  * Callback when user switches to a different mode
  */
  onUpdate: PropTypes.func.isRequired,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** dom element or component to use for outermost wrapper */
  componentEl: props,
  /** margin for component, if any */
  margin: marginPropTypes
};
ThemeToggle.defaultProps = {
  mode: 'auto',
  className: null,
  componentEl: 'div',
  margin: null
};
ThemeToggle.displayName = 'ThemeToggle';

export { Alert, AnnouncementBar, ThemeToggle, Select as VisuallyHidden };
